namespace appn.views.repositoryAdmin.createOrEdit {

    export function init(): void {
        appn.select.init({
            selector: 'select#iconsToDisplay',
            isIconSelect: true
        });

        ($('#Item_InstallTags') as any).select2({
            tags: true,
            theme: 'bootstrap4'
        });
    }
}
